import { coaches } from './coaches'

export type Testimonial = {
  headline?: string
  /** Párrafos separados por una línea en blanco (\n\n). */
  quote: string
  author: string
  role: string
  avatar: string
}

/**
 * Texto de reseñas de MUESTRA — reemplazar cada cita por una reseña real del
 * comprador (y la foto correspondiente en data/coaches.ts) antes de lanzar.
 */
export const shortTestimonials: Testimonial[] = [
  {
    headline: 'I Had No Idea What to Do at Our First Practice.',
    quote:
      'I knew my kid loved baseball, and I wanted to help coach the team. But when it came to planning an actual practice, I wasn’t sure where to start.\n\nHaving a plan laid out for me would have made that first practice a whole lot less intimidating.\n\nNow imagine opening a practice sheet and knowing exactly what comes next.',
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
  {
    quote:
      'I used to spend Sunday night scrolling YouTube trying to build a practice. Now I open the book, grab the sheet for today and I’m out the door. The flowchart alone saved my season.',
    author: coaches[1].name,
    role: coaches[1].role,
    avatar: coaches[1].avatar,
  },
  {
    quote:
      'The age cheat sheet told me exactly what to skip for my 9-10 group. Everything is timed and in order, so I’m not making calls on the fly in front of the parents anymore.',
    author: coaches[2].name,
    role: coaches[2].role,
    avatar: coaches[2].avatar,
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'The confidence scripts are the sleeper. I’m not a baseball guy — having the exact words for a drill and the post-game talk made me look like I knew what I was doing from day one.',
    author: coaches[3].name,
    role: coaches[3].role,
    avatar: coaches[3].avatar,
  },
  {
    quote:
      'Rainout, half the team missing, borrowed field — the Season Toolkit had a plan for all of it. I never get caught improvising anymore.',
    author: coaches[4].name,
    role: coaches[4].role,
    avatar: coaches[4].avatar,
  },
  {
    quote:
      'A whole season already planned, practice by practice. I stopped building drills from scratch and just started coaching. Easily worth more than what I paid.',
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
]
